import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.tsx';
import { ErrorBoundary } from './components/ErrorBoundary';
import { brandConfig, getPageTitle } from './config/brand';

// Set page title and favicon based on brand
document.title = getPageTitle();
const favicon = document.getElementById('favicon') as HTMLLinkElement | null;
if (favicon) favicon.href = brandConfig.faviconSvg;

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>
);
